/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Early_Access_To_Plus_Exlusive_TreeInputs */

const en_early_access_to_plus_exlusive_tree = /** @type {(inputs: Early_Access_To_Plus_Exlusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Early access to Plus exclusive trees`)
};

const ar_early_access_to_plus_exlusive_tree = /** @type {(inputs: Early_Access_To_Plus_Exlusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوصول المبكر إلى أشجار بلس الحصرية`)
};

const de_early_access_to_plus_exlusive_tree = /** @type {(inputs: Early_Access_To_Plus_Exlusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Früher Zugang zu exklusiven Plus-Bäumen`)
};

const es_early_access_to_plus_exlusive_tree = /** @type {(inputs: Early_Access_To_Plus_Exlusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso anticipado a árboles exclusivos Plus`)
};

const fr_early_access_to_plus_exlusive_tree = /** @type {(inputs: Early_Access_To_Plus_Exlusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accès anticipé aux arbres exclusifs Plus`)
};

const it_early_access_to_plus_exlusive_tree = /** @type {(inputs: Early_Access_To_Plus_Exlusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accesso anticipato agli alberi esclusivi Plus`)
};

const ja_early_access_to_plus_exlusive_tree = /** @type {(inputs: Early_Access_To_Plus_Exlusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus限定の木への早期アクセス`)
};

const ko_early_access_to_plus_exlusive_tree = /** @type {(inputs: Early_Access_To_Plus_Exlusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 독점 나무 얼리 액세스`)
};

const pt_br_early_access_to_plus_exlusive_tree = /** @type {(inputs: Early_Access_To_Plus_Exlusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesso antecipado a árvores exclusivas Plus`)
};

const ru_early_access_to_plus_exlusive_tree = /** @type {(inputs: Early_Access_To_Plus_Exlusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ранний доступ к эксклюзивным деревьям Plus`)
};

const th_early_access_to_plus_exlusive_tree = /** @type {(inputs: Early_Access_To_Plus_Exlusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าถึงต้นไม้สุดพิเศษสำหรับ Plus ได้ก่อนใคร`)
};

const tr_early_access_to_plus_exlusive_tree = /** @type {(inputs: Early_Access_To_Plus_Exlusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus'a özel ağaçlara erken erişim`)
};

const zh_cn_early_access_to_plus_exlusive_tree = /** @type {(inputs: Early_Access_To_Plus_Exlusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`抢先使用 Plus 独享树种`)
};

const zh_tw_early_access_to_plus_exlusive_tree = /** @type {(inputs: Early_Access_To_Plus_Exlusive_TreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搶先使用 Plus 獨享樹種`)
};

/**
* | output |
* | --- |
* | "Early access to Plus exclusive trees" |
*
* @param {Early_Access_To_Plus_Exlusive_TreeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const early_access_to_plus_exlusive_tree = /** @type {((inputs?: Early_Access_To_Plus_Exlusive_TreeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Early_Access_To_Plus_Exlusive_TreeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_early_access_to_plus_exlusive_tree(inputs)
	if (locale === "ar") return ar_early_access_to_plus_exlusive_tree(inputs)
	if (locale === "de") return de_early_access_to_plus_exlusive_tree(inputs)
	if (locale === "es") return es_early_access_to_plus_exlusive_tree(inputs)
	if (locale === "fr") return fr_early_access_to_plus_exlusive_tree(inputs)
	if (locale === "it") return it_early_access_to_plus_exlusive_tree(inputs)
	if (locale === "ja") return ja_early_access_to_plus_exlusive_tree(inputs)
	if (locale === "ko") return ko_early_access_to_plus_exlusive_tree(inputs)
	if (locale === "pt_br") return pt_br_early_access_to_plus_exlusive_tree(inputs)
	if (locale === "ru") return ru_early_access_to_plus_exlusive_tree(inputs)
	if (locale === "th") return th_early_access_to_plus_exlusive_tree(inputs)
	if (locale === "tr") return tr_early_access_to_plus_exlusive_tree(inputs)
	if (locale === "zh_cn") return zh_cn_early_access_to_plus_exlusive_tree(inputs)
	return zh_tw_early_access_to_plus_exlusive_tree(inputs)
});